module.exports = __webpack_public_path__ + "6c2f5079a734c562437eb2830cd016b7.svg";